import { PayloadAction, ActionReducerMapBuilder } from "@reduxjs/toolkit";
import { IFiltersData } from "src/@types/filtering";
import { getFiltersValuesAsync } from "./actions";
import { IFiltersState } from "./slice";

type ActionReducerMapBuilderWithFiltersState =
  ActionReducerMapBuilder<IFiltersState>;

export const getFiltersValuesReducer = (
  builder: ActionReducerMapBuilderWithFiltersState
) => {
  builder.addCase(getFiltersValuesAsync.pending, (state) => {
    state.isLoading = true;
  });

  builder.addCase(
    getFiltersValuesAsync.fulfilled,
    (state, action: PayloadAction<IFiltersData>) => {
      state.isLoading = false;
      state.values = action.payload;
    }
  );

  builder.addCase(getFiltersValuesAsync.rejected, (state) => {
    state.isLoading = false;
    state.values = null;
  });
};
